import { SET_DATA_OPTOUT, SET_DATA_OPTOUT_DONE, SET_DATA_OPTOUT_ERR, SET_DATA_OPTOUT_RESET } from './actionTypes';
export const setDataOptout = (data) => ({
    type: SET_DATA_OPTOUT,
    data
});
export const setDataOptoutDone = (data) => ({
    type: SET_DATA_OPTOUT_DONE,
    data
});
export const setDataOptoutError = (data) => ({
    type: SET_DATA_OPTOUT_ERR,
    errorMessage: data
});
export const setDataOptoutReset = () => ({
    type: SET_DATA_OPTOUT_RESET
});
//# sourceMappingURL=actionCreators.js.map